import { styled, Box, Button, makeStyles, createStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  PRIMARY_CONTAINER_BORDER,
  PLAIN_TEXT,
  DARK_TEXT,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_ICON,
  DARK_SECONDARY_BUTTONBACKGROUND,
  LIGHTER_BUTTON_BACKGROUND,
} = COLORS;

export const MainCont = styled(Box)(({ theme }) => ({}));

export const DropCont = styled(Box)(({ theme }) => ({
  backgroundColor: `${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING} !important`,
}));

export const Drop = styled(Box)(({ theme }) => ({
  minHeight: 344,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 8,
  borderColor: PRIMARY_CONTAINER_BORDER,
  borderStyle: 'dashed',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer',
  justifyContent: 'center',
  textAlign: 'center',
  backgroundColor: `${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING} !important`,
}));

export const ClearButton = styled(Button)(({ theme }) => ({
  backgroundColor: `${theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING} !important`,
  border: `solid 1px ${PRIMARY_BUTTON_BORDER}`,
  borderRadius: 8,
  width: '100%',
  marginTop: 20,
  height: 51,
}));

export const ProgressOverlay = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99,
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    circle: {
      stroke: 'url(#linearColors)',
      position: 'absolute',
    },
    cardItem: {
      height: 60,
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
      borderRadius: 8,
      padding: '10px 15px',
      '&:not(:first-child)': {
        marginTop: 15,
      },

      '& .MuiSvgIcon-root': {
        '&.documentIcon path': {
          fill: PRIMARY_ICON,
        },
      },
    },
    buttonContainer: {
      alignItems: 'center',
      display: 'flex',
      position: 'relative',
    },
    buttonCls: {
      background: theme.palette.type === 'dark' ? DARK_SECONDARY_BUTTONBACKGROUND : LIGHTER_BUTTON_BACKGROUND,
      height: 32,
      border: 'none',
      width: 85,
      marginLeft: 5,
    },
  }),
);
